const Vue = require('vue');

require('./components/Counter')
require('./components/HomeHero')
require('./components/IndustryTileButton')
require('./components/TestimonialCarousel')

var app = new Vue({
  el: '#app'
})